var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ssh-proxy-match-list',{attrs:{"id":_vm.id,"proxyEndpointId":_vm.resId,"getParams":_vm.getParams}})}
var staticRenderFns = []

export { render, staticRenderFns }